export default __webpack_public_path__ + "static/media/squid_game.7ffc773a.png";